import React from 'react';
import { PLAY_STORE_URL } from '../config/constants';
import homeScreen from '../assets/images/app-screen-home.jpg';
import loginScreen from '../assets/images/app-screen-login.jpg';
import styles from '../styles/AppDownload.module.css';

const FEATURES = [
    { icon: '📜', text: 'Personalised Kundli, Vastu & Remedies reports' },
    { icon: '💳', text: 'Easy wallet recharge, secure payments & order tracking' }
];

// Google Play mark (multi-colour triangle)
const PlayIcon = () => (
    <svg className={styles.playIcon} viewBox="0 0 512 512" aria-hidden="true" focusable="false">
        <polygon points="48,32 268,256 48,480" fill="#00A0FF" />
        <polygon points="48,32 340,189 268,256" fill="#00F076" />
        <polygon points="340,189 464,256 340,323 268,256" fill="#FFE000" />
        <polygon points="268,256 340,323 48,480" fill="#FF3A44" />
    </svg>
);

const AppDownload = () => (
    <section className={styles.appSection} id="app-download">
        <div className={styles.inner}>
            <div className={styles.content}>
                <span className={styles.eyebrow}>THE ASTROSHUBH APP</span>
                <h2 className={styles.heading}>
                    Your personal astrology guide, available to you{' '}
                    <span className={styles.highlight}>24×7</span>.
                </h2>
                <p className={styles.description}>
                    Get personalised Kundli reports, Vedic remedies and Vastu guidance right on your phone. Track
                    your orders and recharge your wallet anytime, anywhere.
                </p>

                <ul className={styles.features}>
                    {FEATURES.map((f) => (
                        <li key={f.text} className={styles.feature}>
                            <span className={styles.featureIcon} aria-hidden="true">{f.icon}</span>
                            <span>{f.text}</span>
                        </li>
                    ))}
                </ul>

                <a
                    className={styles.playBadge}
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Get it on Google Play"
                >
                    <PlayIcon />
                    <span className={styles.playText}>
                        <span className={styles.playSmall}>GET IT ON</span>
                        <span className={styles.playBig}>Google Play</span>
                    </span>
                </a>
            </div>

            <div className={styles.visual}>
                <img
                    src={loginScreen}
                    alt="AstroShubh app login screen"
                    className={`${styles.shot} ${styles.shotBack}`}
                    loading="lazy"
                />
                <img
                    src={homeScreen}
                    alt="AstroShubh app home screen with Prasna Kundli and Remedy Services"
                    className={`${styles.shot} ${styles.shotFront}`}
                    loading="lazy"
                />
            </div>
        </div>
    </section>
);

export default AppDownload;
